(function ($) {

    if (TL.Signin === undefined) {
        TL.Signin = {};
    }

    var travelanium = {

        onLoad() {
            
        },

        createCookie(id, name, email) {
            
        },
        
        getName() {
                         
        },

        getInfo() {

        },

        verify(propertyId, name, email, isSigned) {
            
        },

        logout() {

        }
    }


    if (TL.Signin.Hotel === undefined) {
        TL.Signin.Hotel = travelanium;
    }


})(jQuery);

